import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames';
import { getSafe } from '@/helpers/global'
import '@/assets/styles/components/order/order-information.scss'
import { formatFunctions } from '../../helpers/functions';
import { dataType } from '@/constants/data-type';
import { ORDER_MODE } from '@/constants/app';

class OrderInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    }
  }

  render() {
    const { mode } = this.props;
    const { data } = this.state;
    return (
        <div className={classnames("order-information-container", mode === ORDER_MODE.DETAIL && 'detail-table')}>
          {data.map(item =>
              <div key={item.label} className="row-item">
                <span className='label'>{item.label}</span>
                <span
                    className={classnames('value', getSafe(() => item.classStyle.join(' '), ''))}>{this.renderOrderDirection(item.value)}</span>
              </div>
          )}
        </div>
    )
  }

  renderOrderDirection(value) {
    const { language } = this.props;
    if (value === 'B' || value === 'S') {
      const bgClass = value === 'B' ? 'rise-color' : 'fall-color';
      return (
          <span className={bgClass}>
          <span>{language[value]}</span>
        </span>
      )
    }
    return (
        <span>
        <span>{value}</span>
      </span>
    )
  }

  handleCancelMode = () => {
    const { order, language, isMobile } = this.props;
    const data = [
      { label: language.common_order_id, value: order.orderGroupID },
      {
        label: language.common_order_direction,
        value: order.bs === 'B' ? language.common_buy : language.common_sell,
        classStyle: [`order-direction-${order.bs.toLowerCase()}`]
      },
      { label: language.common_order_type, value: language[`order_type_${order.orderType.toLowerCase()}`] },
      { label: language.common_symbol, value: `${order.marketID}.${order.instrumentID}` },
      { label: language.common_name, value: this.mapStockName(order) ?  this.mapStockName(order) : '-' },
      {
        label: language.common_price,
        value: order.price ? `${order.currencyID} ${formatFunctions.dataFormat(order.price, dataType.CURRENCY)}` : '-'
      },
      {
        label: language.common_trigger_type,
        value: getSafe(() => language[`order_stop_price_type_${order.stopOrderType}`], '-')
      },
      {
        label: language.common_trigger_price,
        value: order.stopPrice ? `${order.currencyID} ${formatFunctions.dataFormat(order.stopPrice, dataType.CURRENCY)}` : '-'
      },
      {
        label: language.common_quantity,
        value: this.handleQuantityText(order.qty)
      },
      {
        label: language.common_good_till_date,
        value: order.goodTillDate ? formatFunctions.dataFormat(order.goodTillDate, dataType.SHORT_DATE) : '-'
      },
      {
        label: language.common_commission_fees,
        value: (order.grossAmt && order.netAmt) ? `${order.currencyID} ${formatFunctions.dataFormat(Math.abs(order.netAmt - order.grossAmt), dataType.CASH)}` : '-'
      },
    ]
    if (!isMobile) {
      data.push({
        label: language.common_gross_amount,
        value: order.netAmt
            ? `${order.currencyID} ${formatFunctions.dataFormat(order.netAmt, dataType.CASH)}`
            : `${order.currencyID} ${formatFunctions.dataFormat(order.price * order.qty, dataType.CASH)}`,
        classStyle: ['gross-amount']
      })
    }
    this.setState({ data })
  }

  handleDetailMode = () => {
    const { order, language } = this.props;
    const data = [
      { label: language.common_order_id, value: order.orderGroupID },
      {
        label: language.common_order_direction,
        value: order.bs === 'B' ? language.common_buy : language.common_sell,
        classStyle: [`order-direction-${order.bs.toLowerCase()}`]
      },
      { label: language.common_symbol, value: `${order.marketID}.${order.instrumentID}` },
      {
        label: language.common_price,
        value: order.price ? `${order.currencyID} ${formatFunctions.dataFormat(order.price, dataType.CURRENCY)}` : '-'
      },
      { label: language.common_name, value: this.mapStockName(order) ?  this.mapStockName(order) : '-'},
      {
        label: language.common_quantity,
        value: this.handleQuantityText(order.qty)
      },
      { label: language.common_order_type, value: language[`order_type_${order.orderType.toLowerCase()}`] },
      {
        label: language.common_filled_quantity,
        value: this.handleQuantityText(order.filledQty)
      },
      {
        label: language.common_trigger_type,
        value: getSafe(() => language[`order_stop_price_type_${order.stopOrderType}`], '-')
      },
      {
        label: language.common_trigger_price,
        value: order.stopPrice ? `${order.currencyID} ${formatFunctions.dataFormat(order.stopPrice, dataType.CURRENCY)}` : '-'
      },
      {
        label: language.common_good_till_date,
        value: order.goodTillDate ? formatFunctions.dataFormat(order.goodTillDate, dataType.SHORT_DATE) : '-'
      },
      {
        label: language.common_cancelled_quantity,
        value: this.handleQuantityText(order.cancelQty)
      },
      {
        label: language.common_transaction_time,
        value: order.inputTime ? formatFunctions.dataFormat(order.inputTime, dataType.LONG_DATE) : '-'
      },
      {
        label: language.common_outstanding_quantity,
        value: this.handleQuantityText(order.osQty)
      },
      {
        label: language.common_commission_fees,
        value: (order.grossAmt && order.netAmt) ? `${order.currencyID} ${formatFunctions.dataFormat(Math.abs(order.netAmt - order.grossAmt), dataType.CASH)}` : '-'
      },
      {
        label: language.common_gross_amount,
        value: order.netAmt ? `${order.currencyID} ${formatFunctions.dataFormat(order.netAmt, dataType.CASH)}` : '-'
      }
    ]
    this.setState({ data })
  }

  handleModifyMode = () => {
    const { order, language } = this.props;
    const data = [
      { label: language.common_order_id, value: order.orderGroupID },
      {
        label: language.common_order_direction,
        value: order.bs === 'B' ? language.common_buy : language.common_sell,
        classStyle: [`order-direction-${order.bs.toLowerCase()}`]
      },
      { label: language.common_order_type, value: language[`order_type_${order.orderType.toLowerCase()}`] },
      { label: language.common_symbol, value: `${order.marketID}.${order.instrumentID}` },
      { label: language.common_name, value: this.mapStockName(order) ?  this.mapStockName(order) : '-' },
      {
        label: language.common_trigger_type,
        value: getSafe(() => language[`order_stop_price_type_${order.stopOrderType}`], '-')
      },
      {
        label: language.common_trigger_price,
        value: order.stopPrice ? `${order.currencyID} ${formatFunctions.dataFormat(order.stopPrice, dataType.CURRENCY)}` : '-'
      },
      {
        label: language.order_original_properties.format(language.common_price),
        value: order.price ? `${order.currencyID} ${formatFunctions.dataFormat(order.price, dataType.CURRENCY)}` : '-'
      },
      {
        label: language.order_original_properties.format(language.common_quantity),
        value: this.handleQuantityText(order.qty)
      },
      // {
      //   label: language.common_outstanding_quantity,
      //   value: this.handleQuantityText(order.osqty)
      // }
    ]
    this.setState({ data })
  }

  handleQuantityText(value) {
    const { language } = this.props;
    let text = '-';
    if (value !== null) {
      text = `${formatFunctions.dataFormat(value, dataType.NUMBER)} ${language.common_share.format((language.lang === 'en_US' && value > -1) ? 's' : '')}`
    }
    return text;
  }

  computeData() {
    const { mode } = this.props;
    switch (mode) {
      case ORDER_MODE.CANCEL:
        this.handleCancelMode();
        break;
      case ORDER_MODE.MODIFY:
        this.handleModifyMode();
        break;
      case ORDER_MODE.DETAIL:
        this.handleDetailMode();
        break;
      default:
        break;
    }
  }

  componentDidMount() {
    this.computeData();
  }

  mapStockName(data){
    const { language } = this.props
    let stockName = '' 
    if(language.title === 'zh_TW' || language.title === 'zh_CN'){
      if(data.instrumentChineseName){
        stockName = data.instrumentChineseName
      }else{
        stockName = data.instrumentName
      }
    }else{
      stockName = data.instrumentName
    }
    return stockName
  }
}

export default connect(
    state => ({
      language: state.app.language,
      isMobile: state.app.isMobile,
    })
)(OrderInformation)
